import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export default {
  alterarSenha: (atual, novo) => {
    return Vue.http.post('/api/alteraremail', { atual, novo }).then(response => response.data);
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/alterar-email/servico.js